import { ORG_MODEL_TOKEN_LIMITS_QUERY_KEY } from "@frontend-shared/constants";
import type { IOrganizationModelTokenLimits } from "@frontend-shared/types";
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { organizationApi } from "@/api/services";

export const useGetOrganizationModelTokenLimits = (
  organizationUuid?: string,
): UseQueryResult<IOrganizationModelTokenLimits> => {
  return useQuery({
    queryKey: [ORG_MODEL_TOKEN_LIMITS_QUERY_KEY, organizationUuid],
    queryFn: () => organizationApi.getModelTokenLimits(organizationUuid ?? ""),
    enabled: !!organizationUuid,
  });
};
